// extracted by mini-css-extract-plugin
export default {"abv_card":"ForPartners_abv_card__kj3in","highlightedText":"ForPartners_highlightedText__vdt23","lastGridEl":"ForPartners_lastGridEl__OYW63"};